export function filterForFleet(companyId, startDate, endDate) {
  if(startDate && endDate)
    return `&filter={${inqlude}, ${fields}, "where": {"and": [{"companyId":"${companyId}"},
                    {"or":[{"orderStatus": "canceled"}, {"orderStatus":"returned"}, {"orderStatus":"delivered"}]},
                    {"processedAt": { "between": [${startDate}, ${endDate}]}}]}}`;
  else
    return `&filter={${inqlude}, ${fields}, "where": {"and": [{"companyId":"${companyId}"},
                    {"or":[{"orderStatus": "canceled"}, {"orderStatus":"returned"}, {"orderStatus":"delivered"}]}]}}`;
}

export function filterForDispatcher(dispatcherId, startDate, endDate) {
  if(startDate && endDate)
    return `&filter={${inqlude}, ${fields}, "where":{"and": [{"dispatcherId": "${dispatcherId}"},
                    {"or":[{"orderStatus": "canceled"}, {"orderStatus":"returned"}, {"orderStatus":"delivered"}]},
                    {"processedAt": { "between": [${startDate}, ${endDate}]}}]}}`;
  else
    return `&filter={${inqlude}, ${fields}, "where":{"and": [{"dispatcherId": "${dispatcherId}"},
                      {"or":[{"orderStatus": "canceled"}, {"orderStatus":"returned"}, {"orderStatus":"delivered"}]}]}}`;
}

export function filterForOperator(startDate, endDate) {
  if(startDate && endDate)
    return `&filter={${inqlude}, ${fields}, "where":{"and": [{"or":[{"orderStatus": "canceled"},
                    {"orderStatus":"returned"}, {"orderStatus":"delivered"}]},
                    {"processedAt": { "between": [${startDate}, ${endDate}]}}]}}`;
  else
    return `&filter={${inqlude}, ${fields}, "where":{"and": [{"or":[{"orderStatus": "canceled"},
                    {"orderStatus":"returned"}, {"orderStatus":"delivered"}]}]}}`;
}

const fields = `"fields": [
  "id", "orderStatus", "processedAt", "vehicleType", "createdBy", "deliveryCommission", "cashOnDeliveryAmount", "cashOnDelivery", "driverId"
]`;
const inqlude = `"include": [
  {
    "relation": "driver",
    "scope": {
       "fields": ["id", "firstName"]
     }
  }
]`;



// WEBPACK FOOTER //
// ./src/businessLogic/filtersForHistoryGenerator.js